/** The campaign editor's state: the shared record editor with the campaign form's rules. */
import type { TicketSalesCampaign } from '@bonsai/shared';

import {
  useRecordEditor,
  type RecordEditor,
  type RecordEditorOptions,
} from '../../shared/editor-page/use-record-editor';

import {
  campaignToForm,
  isCampaignFormDirty,
  validateCampaignForm,
  type CampaignFormErrors,
  type CampaignFormValues,
} from './campaign-form';
import { saveErrorToForm } from './save-error';

export type CampaignEditorOptions = RecordEditorOptions<CampaignFormValues, TicketSalesCampaign>;
export type CampaignEditor = RecordEditor<CampaignFormValues, CampaignFormErrors>;

const RULES = {
  toForm: campaignToForm,
  validate: validateCampaignForm,
  isDirty: isCampaignFormDirty,
  saveErrorToForm,
};

export function useCampaignEditor(options: CampaignEditorOptions): CampaignEditor {
  return useRecordEditor(RULES, options);
}
